export function getFootballTeamFromOrderObject(orderObject){
    console.log("pxx1:++++++++++++++: getFootballTeamFromOrderObject");

    if(orderObject.itemSelected === 'football'){
        console.log("pxx12 its football");

        //CHECK ARRAY
        if(orderObject.singleOrderArray && orderObject.singleOrderArray.length > 0){
            console.log("pxx13 singleOrderArray is not empty");

            if(orderObject.singleOrderArray[0]){
                console.log("pxx14 singleOrderArray first item is there");

                if(orderObject.singleOrderArray[0].teamSelection){
                    console.log("pxx15 got the team!:"+orderObject.singleOrderArray[0].teamSelection);
                    return orderObject.singleOrderArray[0].teamSelection;

                }else{
                    console.log("pxx14 orderObject.singleOrderArray[0].teamSelection is empty");
                    return "null";
                }

            }else{
                console.log("pxx14 orderObject.singleOrderArray[0]is empty");
                return "null";
            }

        }else{
            console.log("pxx13 singleOrderArray is empty");
            return "null";
        }

    }else {
        return "null"
    }
}


// WEBPACK FOOTER //
// ./src/components/newSite/FacebookPixelFunctions/PixelFunctions.js